// extracted by mini-css-extract-plugin
export default {"next_order":"Rz","recurringdis":"Sz","reactivate_button":"Tz","order__summary_title":"Uz","order__summary_items":"Vz","order__summary_item":"Wz","order__summary_item_title":"Xz","order__summary_item_quantity":"Yz","order__item_separator":"Zz","discount":"aA","promowrapper":"bA"};
    if(module.hot) {
      // 1738064238494
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  